const getQueryParams = () => {
    const params = new URLSearchParams(window.location.search);
    return {
        serieId: params.get("serie_id"),
        versionId: params.get("version_id")
    };
};

export const seriesList = () => {
    const ulSerie = document.querySelector("#serieList");
    const ulVersion = document.querySelector("#versionList");
    const serieSelected = document.querySelector("#serieSelected");
    const versionSelected = document.querySelector("#versionSelected");
    const inputSerie = document.querySelector("#inputSerie");
    const inputVersion = document.querySelector("#inputVersion");
    const selectSerie = document.querySelector("#selectSerie");
    const selectVersion = document.querySelector("#selectVersion");

    if (ulSerie) {
        fetch("/api/vehicles/series/")
            .then((response) => response.json())
            .then((series) => {
                const { serieId, versionId } = getQueryParams();

                series.forEach((serie) => {
                    // Crear un li por cada serie
                    const liSerie = document.createElement("li");
                    liSerie.textContent = serie.name;
                    liSerie.id = serie.id;
                    liSerie.className = "option";

                    const handleSerieClick = () => {
                        fetch(`/api/vehicles/series/?serie_id=${serie.id}`)
                            .then((response) => response.json())
                            .then((serie) => serie[0].versions)
                            .then((versions) => {
                                ulVersion.innerHTML = ""; // Limpiar versiones anteriores

                                versions.forEach((version) => {
                                    // Crear un li por cada versión y lo agrego al ul
                                    const liVersion = document.createElement("li");
                                    liVersion.textContent = version.name;
                                    liVersion.className = "option";
                                    liVersion.id = version.id;
                                    ulVersion?.appendChild(liVersion);

                                    const handleVersionClick = () => {
                                        versionSelected.textContent = version.name;
                                        inputVersion.value = version.id;
                                        if (inputVersion.value) {
                                            selectVersion.classList.remove("--has-error");
                                        }

                                        // Obtener el elemento se agregarán los elementos
                                        const parentElement = document.querySelector("#cotizarForm");

                                        // Crear el div para mostrar la versión seleccionada
                                        let versionDiv = document.querySelector(".version_box");
                                        if (!versionDiv) {
                                            versionDiv = document.createElement("div");
                                            versionDiv.classList.add("version_box");
                                            versionDiv.id = "version_box";
                                        }

                                        let versionText = document.querySelector(".version_box_version");
                                        if (!versionText) {
                                            versionText = document.createElement("p");
                                            versionText.classList.add("version_box_version");
                                            versionText.id = "version_box_version";
                                            versionText.textContent = version.name;
                                            versionDiv.appendChild(versionText);
                                        } else {
                                            versionText.textContent = version.name;
                                        }

                                        let versionImg = document.querySelector(".version_box_img");
                                        if (!versionImg) {
                                            versionImg = document.createElement("img");
                                            versionImg.classList.add("version_box_img");
                                            versionImg.id = "version_box_img";
                                            versionImg.alt = version.name;
                                            versionImg.src = version.image.url;
                                            versionDiv.appendChild(versionImg);
                                        } else {
                                            versionImg.alt = version.name;
                                            versionImg.src = version.image.url;
                                        }

                                        if (!document.querySelector(".version_box")) {
                                            const button = document.querySelector("#cotizarFormBtn");
                                            parentElement?.insertBefore(versionDiv, button);
                                        }
                                    };

                                    liVersion.addEventListener("click", handleVersionClick);

                                    // Si la version está en los query params
                                    if (versionId && version.id.toString() === versionId) {
                                        handleVersionClick();
                                    }
                                });
                            });

                        serieSelected.textContent = serie.name;
                        versionSelected.textContent = "Select version";
                        inputVersion.value = "";
                        inputSerie.value = serie.id;
                        if (inputSerie.value) {
                            selectSerie.classList.remove("--has-error");
                        }
                    };

                    liSerie.addEventListener("click", handleSerieClick);
                    ulSerie?.appendChild(liSerie);

                    // Si la serie está en los query params
                    if (serieId && serie.id.toString() === serieId) {
                        handleSerieClick();
                    }
                });
            })
            .catch((error) => console.error(error));
        }
};


export const quotationBtnHandler = () => {
    const form = document.querySelector('#cotizarForm');

    if (form) {
        const btn = form.querySelector('.btn-small');
        btn?.addEventListener('click', () => {
            const errorElements = form.querySelectorAll('.--has-error');
            if (errorElements.length == 0) {
                btn.disabled = true;
            }
        });
    }
}
